/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentDetailByIdQueryResponse, GetFragmentDetailByIdPathParams, GetFragmentDetailById404 } from "../models/GetFragmentDetailById";

export function getGetFragmentDetailByIdUrl(id: GetFragmentDetailByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/fragments/${id}` as const }
  return res
}

/**
 * @summary Get one fragment by id
 * {@link /fragments/:id}
 */
export async function getFragmentDetailById(id: GetFragmentDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentDetailByIdQueryResponse, ResponseErrorConfig<GetFragmentDetailById404>, unknown>({ method : "GET", url : getGetFragmentDetailByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}